import CheckIcon from "@redotech/redo-icons/check.svg";
import RefreshIcon from "@redotech/redo-icons/refresh-cw-01.svg";
import StarsIcon from "@redotech/redo-icons/stars-01.svg";
import XCloseIcon from "@redotech/redo-icons/x-close.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoIcon } from "@redotech/redo-web/arbiter-components/icon/redo-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const AiCopilotDraftNotice = memo(function AiCopilotDraftNotice({
  loading,
  suggestedReply,
  onAccept,
  onDismiss,
  onRefresh,
}: {
  loading: boolean;
  suggestedReply: string;
  onAccept: () => void;
  onDismiss: () => void;
  onRefresh: () => void;
}) {
  const hasSuggestion = suggestedReply.trim().length > 0;

  return (
    <Flex
      bgColor="secondary"
      borderColor="primary"
      borderStyle="solid"
      borderWidth="1px"
      dir="column"
      gap="sm"
      p="md"
      radius="sm"
    >
      <Flex align="center" gap="md" justify="space-between">
        <Flex align="center" gap="sm" minW="none">
          <RedoIcon color="warning" Icon={StarsIcon} size={16} />
          <Text fontSize="sm" fontWeight="semibold">
            AI suggested reply
          </Text>
        </Flex>
        <Flex align="center" gap="sm">
          <RedoButton
            disabled={loading}
            hierarchy="tertiary"
            IconLeading={RefreshIcon}
            onClick={onRefresh}
            size="sm"
            text="Refresh"
          />
          <RedoButton
            disabled={loading}
            hierarchy="tertiary"
            IconLeading={XCloseIcon}
            onClick={onDismiss}
            size="sm"
            text="Dismiss"
          />
          <RedoButton
            disabled={!hasSuggestion || loading}
            hierarchy="primary"
            IconLeading={CheckIcon}
            onClick={onAccept}
            size="sm"
            text="Accept"
          />
        </Flex>
      </Flex>
      <Text
        className="max-h-32 overflow-auto whitespace-pre-wrap"
        fontSize="sm"
        textColor={hasSuggestion ? "primary" : "secondary"}
      >
        {hasSuggestion ? suggestedReply : "Drafting..."}
      </Text>
    </Flex>
  );
});
